import { Link } from "gatsby";
import React, { Component } from "react";
import { Form, Col, Button } from "react-bootstrap";
import ContactUs from "../images/contact-us.svg";
import "font-awesome/css/font-awesome.min.css";
import AniLink from "gatsby-plugin-transition-link/AniLink";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      workingat: "",
      message: "",
      successMessage: "",
      resColor: "",
      isMobile: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (!this.state.isMobile) {
      if (window.innerWidth <= 575) {
        this.setState({ isMobile: true });
      }
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    const { name, email, workingat, message } = this.state;
    let fieldValidation = true;
    if (message === "") {
      this.setState({
        successMessage: "Let us know how we can help",
        resColor: "text-danger",
      });
      fieldValidation = false;
    }
    if (workingat === "") {
      this.setState({
        successMessage: "Please fill working at",
        resColor: "text-danger",
      });
      fieldValidation = false;
    }
    if (email === "") {
      this.setState({
        successMessage: "We can't reach you without an email",
        resColor: "text-danger",
      });
      fieldValidation = false;
    }
    if (name === "") {
      this.setState({
        successMessage: "Please fill your name",
        resColor: "text-danger",
      });
      fieldValidation = false;
    }
    if (fieldValidation) {
      this.setState({ successMessage: "" });
      this.submitForm(e);
    }
  }

  submitForm(e) {
    e.preventDefault();
    const { name, email, workingat, message } = this.state;
    let templateParams = {
      data: {
        name: name,
        email: email,
        subject: workingat,
        message: message,
      },
    };
    // Make an API call to https://lh8add1jfj.execute-api.us-east-1.amazonaws.com/prod/mail-form/
    // using fetch. Method should be POST and body should be JSON.stringify(templateParams)
    // Catch errors and set state accordingly.
    fetch(
      "https://lh8add1jfj.execute-api.us-east-1.amazonaws.com/prod/mail-form/mobiux",
      {
        method: "POST",
        body: JSON.stringify(templateParams),
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then(res => {
        // Check the response code and set state accordingly
        if (res.status === 200) {
          this.setState({
            successMessage:
              "Thank you for reaching out! We will get back to you soon.",
            resColor: "text-success",
          });
          this.resetForm();
        } else {
          this.setState({
            successMessage: "We couldn't send your message. Please try again!",
            resColor: "text-danger",
          });
        }
      })
      .catch(err => {
        console.error(
          "Oh well, you failed. Here some thoughts on the error that occured:",
          err
        );
        this.setState({
          successMessage: "We couldn't send your message. Please try again!",
          resColor: "text-danger",
        });
      });
  }
  resetForm() {
    this.setState({
      name: "",
      email: "",
      workingat: "",
      message: "",
    });
  }
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    return (
      <footer>
        <div className="container mt-5">
          <div className="row">
            <div className="col-md-6 contact-details p-4">
              <img className="contact-us" src={ContactUs} alt="contact-us" />
              <div className="row pt-5">
                <div className="col-md-7">
                  <span>
                    <p>
                      Contact us &nbsp; &nbsp;
                      <a
                        className="contact-us"
                        title="Email"
                        href="mailto:hey@mobiux.in"
                      >
                        hey@mobiux.in
                      </a>
                    </p>
                  </span>
                </div>
                <div className="col-md-5">
                  <span className="contact-us">
                    <p>+91-9880160085</p>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6 p-4">
              <h1 className="footer-text">{this.props.contactTitle}</h1>
              <Form onSubmit={e => this.handleSubmit(e)}>
                <Form.Group className="mt-5">
                  <Form.Row className="mt-4 ml-0">
                    <label>My name is</label>
                    <Col>
                      <Form.Control
                        size="sm"
                        type="text"
                        name="name"
                        value={this.state.name}
                        onChange={e => this.handleChange(e)}
                      />
                    </Col>
                  </Form.Row>
                  <Form.Row className="mt-4 ml-0">
                    <label>Email ID</label>
                    <Col>
                      <Form.Control
                        size="sm"
                        type="email"
                        name="email"
                        value={this.state.email}
                        onChange={e => this.handleChange(e)}
                      />
                    </Col>
                  </Form.Row>
                  <Form.Row className="mt-4 ml-0">
                    <label>Working at</label>
                    <Col>
                      <Form.Control
                        size="sm"
                        type="text"
                        name="workingat"
                        value={this.state.workingat}
                        onChange={e => this.handleChange(e)}
                      />
                    </Col>
                  </Form.Row>
                  <Form.Row className="mt-4 ml-0">
                    <label>How can we help</label>
                    <Col>
                      <Form.Control
                        size="sm"
                        type="text"
                        name="message"
                        value={this.state.message}
                        onChange={e => this.handleChange(e)}
                      />
                    </Col>
                  </Form.Row>
                  {this.state.successMessage !== "" ? (
                    <div className="mt-4">
                      <h6 className={this.state.resColor}>
                        {this.state.successMessage}
                      </h6>
                    </div>
                  ) : (
                    ""
                  )}
                  <Button
                    className="button float-right mt-5 pl-5 pr-5"
                    type="submit"
                  >
                    Send
                  </Button>
                </Form.Group>
              </Form>
            </div>
          </div>
          <div className="row contact-detail align-items-center mt-5">
            <div className="col-md-6 pl-4 pr-4">
              <p>
                <Link to="/">
                  <span
                    style={{
                      fontSize: "1.225rem",
                      fontWeight: "900",
                      fontFamily: "Flama-Bold",
                    }}
                  >
                    MOBIUX
                  </span>
                </Link>
                &nbsp; Labs &nbsp; &nbsp;Ground Floor, 1507, 11th Cross,
                <br />
                19th Main, Sector 1, HSR Layout, Bangalore
              </p>
            </div>
            <div className="col-md-6 menu-link pl-4 pr-4">
              <div
                className={
                  this.state.isMobile
                    ? "row justify-content-center pb-4"
                    : "row justify-content-end"
                }
              >
                <div className="">
                  <ul className="nav footer-menu">
                    <AniLink
                      cover
                      direction="down"
                      bg="#000000"
                      duration={1}
                      to="/works/"
                      className="nav-link"
                    >
                      Works
                    </AniLink>
                    <AniLink
                      cover
                      direction="down"
                      bg="#000000"
                      duration={1}
                      to="/services/"
                      className="nav-link"
                    >
                      Offerings
                    </AniLink>
                    <AniLink
                      cover
                      direction="down"
                      bg="#000000"
                      duration={1}
                      to="/company/"
                      className="nav-link"
                    >
                      Company
                    </AniLink>
                    {/* <AniLink
                      cover
                      direction="down"
                      bg="#000000"
                      duration={1}
                      to="/careers"
                      className="nav-link"
                    >
                      Careers
                    </AniLink> */}
                    <Link
                      to="https://angel.co/company/mobiux-labs/jobs/"
                      className="nav-link"
                      target="_blank"
                    >
                      Careers
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-8 col-7 justify-content-start pl-4 pr-4">
              {/* <p><img className="" src={GoogleMap} alt="map" />&nbsp; &nbsp; View on Map</p> */}
              <Link
                to="https://www.google.com/maps/place/Mobiux+Labs/@12.91508,77.6322201,15z/data=!4m5!3m4!1s0x0:0xb60319623095fcf3!8m2!3d12.91508!4d77.6322201"
                target="_blank"
              >
                <a
                  className="fa fa-map-o"
                  title="View on Map"
                  style={{ fontSize: "20px", color: "black" }}
                ></a>
                &nbsp; &nbsp; View on Map
              </Link>
            </div>
            <div className="col-md-4 col-5 social-icons">
              <a
                href="https://www.linkedin.com/company/mobiux/"
                className="fa fa-linkedin"
                target="_blank"
                title="LinkedIn"
              ></a>
              <a
                href="https://dribbble.com/mobiux"
                className="fa fa-dribbble"
                target="_blank"
                title="Dribbble"
              ></a>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
